import React, { Component } from 'react';
import auth from './services/authService'
import * as userService from './services/userService'
class Logout extends Component {
    componentDidMount = async() => {
      let response = await userService.logout()
      return response
    };
    
    render() { 
        return null;
    }
}
 
export default Logout;